import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

export function useFlightStatusPathAnalytics(searchParams, results, aircraftType) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const { flightNumber = "", departureDate = "" } = searchParams ?? {};
  const { arrivalStatus, destinationAirportCode, originationAirportCode } = results?.[0] ?? {};

  useEffect(() => {
    if (pathname.includes("/air/flight-status/path")) {
      setMktgPageData(
        {
          air_bound1_aircrafttype: aircraftType,
          air_bound1_airportcode: `${originationAirportCode}:${destinationAirportCode}`,
          air_bound1_date: departureDate,
          air_bound1_flight_number: flightNumber,
          flight_status: arrivalStatus,
        },
        "fligthStatusResultsPage"
      );
    }
  }, [pathname, results]);
}
